export default (actions: object, status: string) => {
  return Object.values(actions)
    .filter((action) => action[status] !== undefined)
    .map((action) => action[status]);
};
